import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchShowcaseMiniEntity } from '../../domain/entities/BranchShowcaseMiniEntity'
export class BranchShowcaseMiniModel extends BranchShowcaseMiniEntity {
  constructor(dataDto: BranchShowcaseMiniEntity) {
    super()
    mapEntityProperties<BranchShowcaseMiniEntity>(this, dataDto)
  }
}
